import {
  PRIMARY_LANGUAGE_LOCALES,
  withPrimaryLanguage,
} from "./primary-language";

const BUNDLED_LOCALES_LIST_FETCH_TIMEOUT_MS = 3000;

export function parseBundledLocalesList(value: unknown): string[] | null {
  if (
    !Array.isArray(value) ||
    !value.every((locale) => typeof locale === "string")
  ) {
    return null;
  }

  return value;
}

/**
 * Reads `public/locales/locales.json` for selectable locales when CDN manifest
 * discovery is off or unavailable. Remove when foreign locales are CDN-only.
 */
export async function fetchBundledLocalesList(
  timeoutMs = BUNDLED_LOCALES_LIST_FETCH_TIMEOUT_MS
): Promise<string[]> {
  try {
    const response = await fetch("/locales/locales.json", {
      cache: "no-store",
      signal: AbortSignal.timeout(timeoutMs),
    });

    if (!response.ok) {
      return [...PRIMARY_LANGUAGE_LOCALES];
    }

    const parsed = parseBundledLocalesList(await response.json());
    if (parsed === null) {
      return [...PRIMARY_LANGUAGE_LOCALES];
    }

    return withPrimaryLanguage(parsed);
  } catch {
    return [...PRIMARY_LANGUAGE_LOCALES];
  }
}
